import { CSSProperties } from 'react';
import { useFullscreenContext } from '../../../utils/contexts/FullscreenContext';
import { useCurrentUrl } from '../../../utils/routing';
import { CHART_CONTAINER_HEIGHT } from '../constants/utils';
import { ChartMode } from '../types';

const useMinChartHeight = (mode: ChartMode): CSSProperties['height'] => {
  const { isFullScreen } = useFullscreenContext();
  const { isReportInUrl } = useCurrentUrl();

  if (mode === ChartMode.Compact) {
    return '100%';
  }

  const multiplier = isFullScreen || isReportInUrl ? 2 : 1;

  return CHART_CONTAINER_HEIGHT * multiplier;
};

export default useMinChartHeight;
